import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { AssistanceApplicationReviewService } from '../../../../../../services/assistance-application-review.service';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import {
    ASSISTANCE_APPLICATION_DENIAL_REASON_OPTIONS
} from '../../../../../../shared/constants/options/assistance-application-denial-options';
import { AssistanceApplicationDenialReason } from '../../../../../../services/api.client';

@Component({
    selector: 'app-deny-review',
    templateUrl: './deny-review.component.html',
    styleUrls: ['./deny-review.component.scss'],
    standalone: false
})
export class DenyReviewComponent {
    protected readonly ASSISTANCE_APPLICATION_DENIAL_REASON_OPTIONS = ASSISTANCE_APPLICATION_DENIAL_REASON_OPTIONS;
    protected readonly AssistanceApplicationDenialReason = AssistanceApplicationDenialReason;

    constructor(private _reviewService: AssistanceApplicationReviewService) { }

    @Input() assistanceApplicationId: string;
    @Output() closeModal = new EventEmitter();
    public isProcessing = false;

    private _fb = inject(FormBuilder);

    get denialReason(): FormControl<AssistanceApplicationDenialReason> {
        return this.form?.get('denialReason') as FormControl<AssistanceApplicationDenialReason>;
    }

    get otherDenialReason(): FormControl {
        return this.form?.get('otherDenialReason') as FormControl;
    }

    form = this._fb.group({
        denialReason: new FormControl<AssistanceApplicationDenialReason>(null, Validators.required),
        otherDenialReason: new FormControl('')
    });

    onClickCancel(): void {
        this.closeModal.emit();
        this.resetForm();
    }

    onClickConfirmDeny(): void {
        if (this.isProcessing) {
            return;
        }
        if (!this.form.valid) {
            this.form.markAllAsTouched();
            return;
        }
        this.isProcessing = true;
        this._reviewService
            .denyReviewApplication(
                this.assistanceApplicationId,
                this.denialReason.value,
                this.otherDenialReason.value
            )
            .subscribe({
                next: result => {
                    this.isProcessing = false;
                    this.closeModal.emit();
                    window.location.reload();
                },
                error: err => {
                    console.error(err);
                    this.isProcessing = false;
                }
            });
    }

    private resetForm(): void {
        this.denialReason.markAsUntouched();
        this.denialReason.setValue(null);
        this.otherDenialReason.markAsUntouched();
        this.otherDenialReason.setValue('');
    }
}
